// extracted by mini-css-extract-plugin
export default {"comparableHomesNearby":"vNHLMttkEMzWj7cLD6p_"};